import apiCall from './apiCall';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const downloadCsvApi = ({
  url,
  isDownloadXlsx = false,
}: {
  url: string;
  isDownloadXlsx?: boolean;
}) => {
  return apiCall({
    method: 'get',
    url,
    ...(isDownloadXlsx ? { isDownloadXlsx } : {}),
  });
};
